'use client';

import styled from 'styled-components';

import Rating from '@icons/Rating.svg';
import { Spacers } from '@styles/theme';

export const StyledRating = styled(Rating)`
  width: ${Spacers.LG}rem;
  height: ${Spacers.LG}rem;
`;
